/* eslint-disable camelcase */
import { SWRConfiguration } from "swr";
import { ApiResponse, ServerResponse } from "./axiosConfig";
import { useSwrCached } from "./axiosHVS";

export interface VmsesConfig extends Record<string, unknown> {
  id: string;
  options: VmsOptions[];
}
export interface VmsOptions {
  key: string;
  name: string;
  type: string;
  enabled: boolean;
  has_ptz: boolean;
  has_call_to_preset: boolean;
  has_call_to_tour: boolean;
  has_playback: boolean;
  has_export: boolean;
  requires_fps_for_playback: boolean;
  has_bookmark: boolean;
}
export const useVmsesConfig = (
  config?: SWRConfiguration
): ServerResponse<ApiResponse<VmsesConfig>> => {
  const documentKey = `documents/vms_connectors`;
  const vmsConfig = useSwrCached<ApiResponse<VmsesConfig>>(
    `${documentKey}`,
    config
  );

  return vmsConfig;
};
